import axios from "@/axios"; 

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    async getCheckOlt(id) {
  
      try {
        const response = await axios.get(API_URL+`/olt-info-check-olt-telnet/${id}/`);
        return response.data;
      } catch (error) {
        console.error("Error retrieving:", error);
        throw error; 
      }
    },

    
  };
